<template>
  <div class="container">
    <product-image-container
      :tarjetas="tarjetas"
      :quantumObfuscate="quantumObfuscate"
    />
    <p class="product-text">{{ title }}</p>

    <div
      v-if="!latamMillas && !creditoIngreso"
      class="beneficios-container"
      v-bind:class="{ 'small-container': !tiempo }"
    >
      <div class="beneficio-extra" v-if="beneficioExtra">
        <span :data-obfuscate="quantumObfuscate">{{ beneficioExtra }}</span>
        <p>
          <span
            v-if="beneficioExtraDescripcion"
            v-safe-html="beneficioExtraDescripcion"
          />
        </p>
      </div>

      <div class="limite" style="text-align:center">
        <span :data-obfuscate="quantumObfuscate">$ {{ limite }} </span>
        <p>
          límite de compra
          <span v-if="limiteDescripcion"><br />{{ limiteDescripcion }}</span>
        </p>
      </div>

      <div class="tiempo" v-if="porcentajeBonificacion">
        <span :data-obfuscate="quantumObfuscate">{{
          porcentajeBonificacion
        }}</span>
        <p v-if="porcentajeDescripcion" v-safe-html="porcentajeDescripcion"></p>
      </div>
      <div class="mantenimiento" v-if="!beneficioExtra">
        <span
          v-bind:class="{ tachado: mantenimientoBonificado }"
          :data-obfuscate="quantumObfuscate"
        >
          $ {{ mantenimiento }}
        </span>
        <p
          v-if="mantenimientoDescripcion"
          v-safe-html="mantenimientoDescripcion"
        ></p>
      </div>
    </div>

    <div v-if="latamMillas" class="beneficios-container-millas">
      <div class="row">
        <div class="column">
          <div class="c-left">
            <p>
              <strong class="millas" :data-obfuscate="quantumObfuscate">{{
                latamMillas.label
              }}</strong>
              <span
                class="millas-description"
                v-safe-html="latamMillas.description"
              >
              </span>
            </p>
          </div>
        </div>
        <div class="column">
          <div class="c-right">
            <p>
              <strong :data-obfuscate="quantumObfuscate">$ {{ limite }}</strong>
              <span
                >límite de compra<br />
                entre las 2 tarjetas</span
              >
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <div class="c-left">
            <p>
              <strong data-obfuscate>100%</strong>
              <span
                >de bonificación<br />
                en tu cuenta</span
              >
            </p>
          </div>
        </div>
        <div class="column">
          <div class="c-right">
            <p>
              <strong
                v-bind:class="{ tachado: mantenimientoBonificado }"
                :data-obfuscate="quantumObfuscate"
                >$ {{ mantenimiento }}</strong
              >
              <span
                v-if="mantenimientoDescripcion"
                v-safe-html="mantenimientoDescripcion"
              ></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="creditoIngreso" class="beneficios-container-millas">
      <div class="row">
        <div class="column">
          <div class="c-left">
            <p>
              <strong class="millas">{{ creditoIngreso.label }}</strong>
              <span v-safe-html="creditoIngreso.description"></span>
            </p>
          </div>
        </div>
        <div class="column">
          <div class="c-right">
            <p>
              <strong :data-obfuscate="quantumObfuscate">$ {{ limite }}</strong>
              <span
                >límite de compra<br />
                entre las 2 tarjetas</span
              >
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <div class="c-left">
            <p>
              <strong data-obfuscate>100%</strong>
              <span
                >de bonificación<br />
                en tu cuenta</span
              >
            </p>
          </div>
        </div>
        <div class="column">
          <div class="c-right">
            <p>
              <strong
                v-bind:class="{ tachado: mantenimientoBonificado }"
                :data-obfuscate="quantumObfuscate"
                >$ {{ mantenimiento }}</strong
              >
              <span
                v-if="mantenimientoDescripcion"
                v-safe-html="mantenimientoDescripcion"
              ></span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProductImageContainer from "@/components/core/ProductImageContainer";

export default {
  name: "ProductContainer",
  components: {
    ProductImageContainer
  },
  props: {
    title: String,
    limite: String,
    limiteDescripcion: String,
    tiempo: String,
    tiempoDescripcion: String,
    porcentajeBonificacion: String,
    porcentajeDescripcion: String,
    mantenimiento: String,
    mantenimientoDescripcion: String,
    mantenimientoBonificado: Boolean,
    beneficioExtra: String,
    beneficioExtraDescripcion: String,
    tarjetas: Array,
    nTarjetas: {
      type: Number,
      default: 1
    },
    latamMillas: Object,
    creditoIngreso: Object,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
div.container {
  margin-bottom: 44px !important;
}

.beneficios-container-millas {
  padding: 0;
  margin: 0;
}

.millas-description {
  width: 80%;
  margin-left: 10%;
}

.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  border: solid 1px #edeaea;
  margin: 0 0 -1px 0;
}

.column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
}

.c-right {
  text-align: center;
  border-bottom: none;
  border-left: solid 1px #edeaea;
}
.c-right strong {
  color: #666666;
  font-size: 24px;
  padding: 0 30px;
  text-align: center;
  display: block;
}

.c-right span {
  padding: 0 30px;
  font-size: 14px;
  text-align: center;
  display: block;
}

.c-left strong.millas {
  color: #00a5a6;
}

.c-left strong {
  font-size: 24px;
  color: #666666;
  padding: 0 30px;
  text-align: center;
  display: block;
}

.c-left span {
  font-size: 14px;
  padding: 0 30px;
  text-align: center;
  display: block;
}

p.product-text {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 25px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  margin: 40px 0;
  letter-spacing: normal;
  color: #666666;
}

.tachado {
  padding: 0 !important;
  display: inline-block !important;
  position: relative;
}
.tachado:after {
  content: "";
  display: block;
  position: absolute;
  left: -5px;
  right: -5px;
  top: 50%;
  transform: translateY(-50%);
  border-bottom: 2px solid #d11e3d;
}

div.beneficios-container {
  display: flex;
  max-width: 550px;
  justify-content: space-between;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  margin-bottom: 44px;
  /* Este contendor se va un poco fuera del contenedor */
  margin-right: -70px;
}

div.beneficios-container div {
  flex-basis: 33%;
  padding: 10px 0;
}

div.beneficios-container.small-container {
  justify-content: flex-start;
}

div.beneficios-container.small-container div:first-child {
  flex-basis: auto;
  padding-right: 30px;
}
div.beneficios-container.small-container div:last-child {
  flex-basis: auto;
  padding-left: 30px;
}

div.beneficios-container div p {
  font-size: 14px;
  margin: 0;
  margin-top: 9px;
}
div.beneficios-container div:first-child p {
  text-indent: 0.3em;
}

div.beneficios-container div > span {
  font-size: 26px;
  color: #666666;
}

div.beneficio-extra {
  border-right: 1px solid #979797;
  margin-right: 20px;
}

div.limite {
  text-align: left;
}

div.beneficio-extra ~ div.limite {
  text-align: center;
}

div.tiempo {
  border-left: 1px solid #979797;
}

div.mantenimiento {
  border-left: 1px solid #979797;
}

@media screen and (max-width: 1080px) {
  /* Ancho aproximado donde el contenedor solapa */
  div.beneficios-container {
    margin-right: 0;
  }
}

@media screen and (max-width: 600px) {
  p.product-text {
    font-size: 20px;
  }

  div.beneficios-container div > span {
    font-size: 20px;
  }

  div.beneficios-container div p {
    font-size: 10px;
    margin-top: 5px;
  }

  div.beneficios-container div:first-child p {
    margin-top: 5px;
  }

  div.beneficios-container div {
    font-size: 10px;
    padding: 0;
  }

  div.limite {
    text-align: center;
  }

  .c-right strong,
  .c-left strong {
    font-size: 19px;
  }
}
</style>
